import { courseTotalCost } from './trainingCourses'
import { linkedPractices, practiceTotal } from './practices'
import { Practice } from '../types/practice'
import { TrainingCourse } from '../types/trainingCourse'
import { TrainingBillingRecord } from '../types/trainingBilling'

export interface CourseEconomics {
  revenue: number
  costs: number
  margin: number
  invoiced: number
}

// Ricavi: importi (senza IVA) delle pratiche assegnate al corso;
// per i corsi on-demand gli importi di acquisto dei singoli partecipanti
export function courseRevenue(course: TrainingCourse, practices: Practice[]): number {
  if (course.status === 'ondemand')
    return (course.enrollments || []).reduce((s, e) => s + (e.price || 0), 0)
  return linkedPractices(practices, course.courseCode).reduce(
    (s, p) => s + (practiceTotal(p) || 0),
    0,
  )
}

// Fatturato: fatture emesse (con numero) delle pratiche assegnate al corso
export function courseInvoiced(
  course: TrainingCourse,
  practices: Practice[],
  billing: TrainingBillingRecord[],
): number {
  return linkedPractices(practices, course.courseCode).reduce((s, p) => {
    const record = billing.find((r) => r.practiceId === p.id)
    if (!record?.invoice?.number) return s
    return s + (record.invoice.amount ?? practiceTotal(p) ?? 0)
  }, 0)
}

export function courseEconomics(
  course: TrainingCourse,
  practices: Practice[],
  billing: TrainingBillingRecord[],
): CourseEconomics {
  const revenue = courseRevenue(course, practices)
  const costs = courseTotalCost(course)
  return {
    revenue,
    costs,
    margin: revenue - costs,
    invoiced: courseInvoiced(course, practices, billing),
  }
}
